import React from 'react';
import { Box } from '@mui/material';
/**
 * Nothing the page could send a reader's input through: no fetch, no forms, no remote images or media (an image URL
 * is a beacon). Images must be inlined as data: URIs. Fonts and the video hosts LivyHelp already embeds still load.
 */
const CSP = ["default-src 'none'", "script-src 'unsafe-inline'", "style-src 'unsafe-inline' https://fonts.googleapis.com", 'font-src https://fonts.gstatic.com data:', 'img-src data:', 'frame-src https://www.youtube.com https://player.vimeo.com https://www.loom.com https://fast.wistia.net https://play.hubspotvideo.com', "form-action 'none'"].join('; ');

/** Prepended, so the parser puts both in the head ahead of anything the page loads. Links open in a new tab. */
export const framedPage = html => "<meta http-equiv=\"Content-Security-Policy\" content=\"".concat(CSP, "\"><base target=\"_blank\">").concat(html);

/**
 * An uploaded help page, shown exactly as it was written. allow-scripts without allow-same-origin: the page's own
 * script runs in an opaque origin, with no access to this app's session, storage or DOM. Popups may escape the
 * sandbox so its links open as ordinary tabs. Never add allow-same-origin or allow-top-navigation here.
 */
export function LivyPageFrame(_ref) {
  let html = _ref.html,
    title = _ref.title;
  return /*#__PURE__*/React.createElement(Box, {
    component: "iframe",
    title: title || 'Help page',
    sandbox: "allow-scripts allow-popups allow-popups-to-escape-sandbox",
    srcDoc: framedPage(html),
    sx: {
      width: '100%',
      height: '75vh',
      minHeight: 480,
      border: 1,
      borderColor: 'divider',
      borderRadius: '10px',
      bgcolor: '#fff'
    }
  });
}